import { ref } from 'vue';

const isOpen = ref(false);

export function showRestrictedAccess(): void {
    isOpen.value = true;
}

export function closeRestrictedAccess(): void {
    isOpen.value = false;
}

export function useRestrictedAccess() {
    return { isOpen, showRestrictedAccess, closeRestrictedAccess };
}
